module.exports = __webpack_public_path__ + "static/media/mentorhero.becea04e.png";